import script from "./CalendarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarComponent.vue?vue&type=style&index=0&id=17a6f034&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a6f034"]])

export default __exports__